import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import 'modern-normalize/modern-normalize.css'
import './core/styles/reset.css'
import App from './App.tsx'
import './index.css'
import { config } from './config'
import { shouldMockOutcomeQueue, startOutcomeQueueMock } from './dev/mockOutcomeQueue'

// Initialize Sentry for error tracking (only if DSN is configured)
if (config.sentryDsn) {
  Sentry.init({
    dsn: config.sentryDsn,
    environment: config.sentryEnvironment || 'development',
    // Send default PII data (e.g., IP address)
    sendDefaultPii: true,
    beforeSend(event) {
      // Filter out errors from browser extensions (e.g., Bitwarden password manager)
      if (event.exception?.values?.[0]?.value?.includes('Object Not Found Matching Id:')) {
        return null
      }
      return event
    },
  })
}

function mount() {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}

// Dev-only: the Deal Hub outcome queue has no server implementation yet, so
// `?mockQueue=1` serves it from fixtures. Inert in any production build.
if (shouldMockOutcomeQueue()) {
  // Mount after the worker is listening, or the first fetch races it.
  startOutcomeQueueMock().finally(mount)
} else {
  mount()
}
